import { defineMessages } from '@kyruus/intl';

export const messages = defineMessages({
  didYouMean: {
    id: 'noresults.didyoumean',
    description: 'Text for a spelling suggestion',
    defaultMessage: 'Did you mean {suggestion} in {categoryName}?'
  },
  didYouMeanMessage: {
    id: 'noresults.didyoumean',
    description: 'Text for a spelling suggestion',
    defaultMessage: 'Did you mean {suggestion} in {categoryName}?'
  },
  wouldYouLikeToRestartYourSearch: {
    id: 'refineSearch.wouldYouLikeToRestartYourSearch',
    description: 'Text for a link to restart the search',
    defaultMessage: 'Would you like to restart your search for {term}?'
  },
  suggestionsHeader: {
    id: 'noresults.suggestionsheader',
    description: 'Header for search suggestions',
    defaultMessage: 'Suggestions based on your search:'
  }
});
